import { Flex } from '@withjoy/joykit';
import type { ReactNode } from 'react';
import React from 'react';

type ButtonContainerProps = {
  children: ReactNode;
  hidden?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

export const ButtonContainer = (props: ButtonContainerProps) => {
  const { children, hidden, disabled, onClick } = props;

  const clickable = onClick && !hidden && !disabled;

  return (
    <Flex
      flexDirection="row"
      alignItems="center"
      onClick={clickable ? onClick : undefined}
      style={{ cursor: clickable ? 'pointer' : undefined, display: !hidden ? 'flex' : 'none' }}
    >
      {children}
    </Flex>
  );
};
